import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { CollectionCaseRecord, SalesApiService } from './sales-api.service';

@Component({
  standalone: true,
  selector: 'ain-sales-collection-cases',
  imports: [AinPageComponent, AinStateComponent, FormsModule, TableModule, ButtonModule, SelectModule],
  template: `
    <ain-page [title]="t('sales.collections.title')" [description]="t('sales.collections.description')">
      @if (loading()) { <ain-state type="loading" [title]="t('common.loading')" /> } @else {
        <section class="panel">
          <div class="toolbar">
            <button pButton type="button" [label]="t('sales.action.create')" (click)="openCreate()"></button>
            <button pButton type="button" [label]="t('sales.action.refresh')" severity="secondary" (click)="load()"></button>
          </div>
          <label>
            <span>{{ t('columns.status') }}</span>
            <p-select [options]="statusOptions" optionValue="value" [(ngModel)]="filterStatus" [showClear]="true" appendTo="body" (ngModelChange)="load()">
              <ng-template pTemplate="selectedItem" let-item>{{ item ? t(item.labelKey) : t('common.all') }}</ng-template>
              <ng-template pTemplate="item" let-item>{{ t(item.labelKey) }}</ng-template>
            </p-select>
          </label>
          <p-table [value]="rows()" [paginator]="true" [rows]="20">
            <ng-template pTemplate="header">
              <tr><th>{{ t('sales.collections.fields.caseNumber') }}</th><th>{{ t('sales.collections.fields.overdue') }}</th><th>{{ t('columns.status') }}</th><th></th></tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.caseNumber }}</td>
                <td>{{ row.totalOverdueAmount }} {{ row.currencyCode }}</td>
                <td>{{ row.status }}</td>
                <td><button pButton type="button" size="small" [label]="t('sales.action.edit')" (click)="openDetail(row.id)"></button></td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    </ain-page>
  `,
  styles: [`.panel{display:grid;gap:10px}.toolbar{display:flex;gap:8px}label{display:grid;gap:6px;max-width:240px}`]
})
export class SalesCollectionCasesComponent implements OnInit {
  private readonly api = inject(SalesApiService);
  private readonly router = inject(Router);
  private readonly localization = inject(LocalizationService);
  readonly loading = signal(true);
  readonly rows = signal<CollectionCaseRecord[]>([]);
  filterStatus: string | null = null;
  statusOptions = [
    { value: 'Open', labelKey: 'sales.collections.status.open' },
    { value: 'InProgress', labelKey: 'sales.collections.status.inProgress' },
    { value: 'Resolved', labelKey: 'sales.collections.status.resolved' }
  ];
  ngOnInit(): void { this.load(); }
  load(): void {
    this.api.listCollectionCases(this.filterStatus ?? undefined).subscribe({
      next: r => { this.rows.set(r); this.loading.set(false); }
    });
  }
  openCreate(): void { void this.router.navigate(['/sales/collection-cases/new']); }
  openDetail(id: string): void { void this.router.navigate(['/sales/collection-cases', id]); }
  t(key: string): string { return this.localization.translate(key); }
}
